






















































































































































































































































































































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { Employee as IEmployee } from "@/api/models/employee";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import MultiplyEntity from "@/components/form/MultiplyEntity.vue";
import { Course as ICourse } from "@/api/models/course";
import { WidgetCreate as IWidgetCreate } from "@/api/models/widget-create";
import { Widget as IWidget } from "@/api/models/widget";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { Video as IVideo } from "@/api/models/video";
import { WidgetEdit as IWidgetEdit } from "@/api/models/widget-edit";
import api from "@/getinfo-api";
import EditorWithFile from "@/components/EditorWithFile.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import Modal from "@/components/form/Modal.vue";
import { envVars } from "@/plugins/env-vars";

@Component({
  components: { Modal, CustomButton, EditorWithFile, MultiplyEntity }
})
export default class WidgetForm extends Vue {
  @Prop() widget!: IWidget;
  title!: string;
  responsibleId!: string;
  employeeList!: Array<IEmployee>;
  siteUrl!: string | undefined;
  allowedHosts: Array<string> = [];
  settings: any = {
    sourceURI: envVars.getStr("VUE_APP_API_HOST"),
    companyId: this.selectedCompany,
    notification: this.$tc(
      this.$translate.ThankYouYourLearningRequestWasSuccessfullyCreated
    ),
    showHeading: true,
    buttonColor: "#52b232",
    backgroundColor: "#FFFFFF",
    categoryTextColor: "#000000",
    learningTypeColor: "#000000",
    commonTextColor: "#000000",
    showDescription: true,
    showDuration: true,
    showPrice: true,
    responsibleId: undefined,
    formComment: this.$tc(this.$translate.IfAnythingGoesWrongOrYouHaveQuestions)
  }; // free-form object for settings
  widgetCode!: string;

  data() {
    return {
      title: undefined,
      responsibleId: undefined,
      employeeList: undefined,
      siteUrl: undefined,
      widgetCode: undefined
    };
  }

  removeWidget() {
    api.WidgetApi._delete(this.widget.id)
      .then(() => {
        this.$router.push({
          name: "apiKeysMain"
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  copyWidgetScript() {
    try {
      navigator.clipboard.writeText(this.srcScript);
    } catch (e) {
      throw e;
    }
    this.$bvToast.toast(this.$tc(this.$translate.CodeCopiedSuccessfully), {
      variant: "success",
      title: this.$tc(this.$translate.Successful)
    });
  }

  copyWidgetCode() {
    try {
      navigator.clipboard.writeText(this.widgetCode);
    } catch (e) {
      throw e;
    }
    this.$bvToast.toast(this.$tc(this.$translate.CodeCopiedSuccessfully), {
      variant: "success",
      title: this.$tc(this.$translate.Successful)
    });
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get srcScript() {
    const path: string = `<script type="text/javascript" src="${window.location.origin}/widgets/learning-widget.js" async>`;
    // eslint-disable-next-line no-useless-escape
    return path + "<\/script>";
  }

  get srcCopyHead() {
    const path: string = this.$tc(
      this.$translate.InsertTheCodeBelowBeforeTheClosingTag
    );
    // eslint-disable-next-line no-useless-escape
    return path + " <\/head> " + this.$tc(this.$translate.onYourSite);
  }

  get code() {
    return `${this.srcScript}\n${this.widgetCode}`;
  }

  deleteSiteFromArray(site: string) {
    this.allowedHosts = this.allowedHosts.filter(el => {
      return el !== site;
    });
  }

  getEmployee() {
    let params: EmployeeListParams = {
      id: this.selectedCompany,
      roles: ["learning_request_manager"],
      limit: 300
    };
    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.employeeList = res.data.employees;
      this.responsibleId = this.employeeList[0].id;
    });
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  addSite() {
    if (this.siteUrl && this.siteUrl.length > 2) {
      this.allowedHosts.push(this.siteUrl);
      this.siteUrl = undefined;
    } else {
      this.$bvToast.toast("alert", {
        variant: "danger",
        title: this.$tc(this.$translate.Error)
      });
    }
  }

  getSelectedCourse(courses: Array<ICourse>) {
    this.settings.courses = courses.map(el => el.id);
  }

  getSelectedWebinar(webinars: Array<IWebinar>) {
    this.settings.webinars = webinars.map(el => el.id);
  }

  getSelectedVideo(records: Array<IVideo>) {
    this.settings.records = records.map(el => el.id);
  }

  get selectedCompany() {
    return this.$store.getters.selectedCompany.id
      ? this.$store.getters.selectedCompany.id
      : localStorage.getItem("selectedCompany");
  }

  createWidget() {
    if (this.siteUrl && this.siteUrl.length > 2) {
      this.allowedHosts.push(this.siteUrl);
    }
    if (!this.widget) {
      this.settings.responsibleId = this.responsibleId;
      let widgetParams: IWidgetCreate = {
        title: this.title,
        type: "learning_resources",
        settings: this.settings,
        allowedHosts: this.allowedHosts
      };

      api.WidgetApi.create(widgetParams)
        .then((res: { data: IWidget }) => {
          let obj = {
            sourceURI: envVars.getStr("VUE_APP_API_HOST"),
            widgetId: res.data.id,
            token: res.data.app.token
          };
          let encoded = btoa(JSON.stringify(obj));
          this.widgetCode = `<getinfo-pro widget-id="${encoded}"></getinfo-pro>`;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    } else {
      let widgetParams: IWidgetEdit = {
        title: this.title,
        settings: this.settings,
        allowedHosts: this.allowedHosts
      };
      api.WidgetApi.edit(this.widget.id, widgetParams)
        .then(() => {
          this.$router.push({
            name: "apiKeysMain"
          });
          this.$store.dispatch("successToast", {
            message: this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved)
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  // get ownerUserId() {
  //   return this.responsible?.user?.id ? this.responsible?.user?.id : undefined;
  // }

  @Watch("selectedCompany")
  updateEmployee() {
    this.getEmployee();
  }

  created() {
    this.getEmployee();
  }

  mounted() {
    if (this.widget) {
      this.title = this.widget.title;
      this.responsibleId = this.widget.ownerId;
      if (this.widget.app.allowedHosts)
        this.allowedHosts = this.widget.app.allowedHosts;
      this.settings = this.widget.settings;
    }
  }
}
